 export const items = [
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1OdpeZ8AOIJfLVpHdKht7lx6qbgkxuRVD',
      metaData: {
        type: 'image',
        height: 750,
        width: 500,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1qUFLlu6_E3vmbwmb5B4G83URZIWBQFMT',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1FZMR5mkFtPJm7SQFfpOSJ9aLlh2lvZiU',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1DJ42H9H-9Z81Osy4-7_uGhve3DihRmYl',
      metaData: {
        type: 'image',
        height: 800,
        width: 533,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1CbVEk4MBVq2o8K741PFrtqp_enF9dBqB',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1Xyhvvlw0uIpGnOWCqd8NrUJFUu4AdPwI',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1UznBhP2NjL6ID30wdyfPXu5xOh363enN',
      metaData: {
        type: 'image',
        height: 800,
        width: 533,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=16c4YoWfviHAJm6tEwU1uJm7MXx_SP3NL',
      metaData: {
        type: 'image',
        height: 800,
        width: 533,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1-8VClPXoR4yXMzWUMuhCGyk-Okj13lRN',
      metaData: {
        type: 'image',
        height: 800,
        width: 533,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1JchHxesfljOmN_e7svurdROOXNgbomiY',
      metaData: {
        type: 'image',
        height: 800,
        width: 533,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1sc7BcJthY0Y8lmpXKXYvMLRHfPLCWZoz',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=15Aqj5qIj80XG951nP25ss78Wac6199jB',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1B4ymH62jlBTlUfsX8lHmcpkLUkvCejZF',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
    { // Image item:
      itemId: 'sample-id',
      mediaUrl: 'https://drive.google.com/uc?export=view&id=1QuDRNepY27ixKsaA71xeK0AU-Mv8ZthA',
      metaData: {
        type: 'image',
        height: 533,
        width: 800,
        title: 'sample-title',
        description: 'sample-description',
        focalPoint: [0, 0],
        link: {
          url: 'http://example.com',
          target: '_blank'
        },
      }
    },
  ]
